import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ReactComponent as ActiveImg } from "../../../img/ico-account-sleeper.svg";
import { ReactComponent as IdleImg } from "../../../img/ico-account-idle.svg";
import { ReactComponent as LockImg } from "../../../img/ico-account-lock.svg";
import { ReactComponent as WithdrawImg } from "../../../img/ico-account-withdraw.svg";

import { ReactComponent as AdminImg } from "../../../img/ico-login-admin.svg";
import { ReactComponent as DomainImg } from "../../../img/ico-login-admin-gray.svg";
import { ReactComponent as UserImg } from "../../../img/ico-login-user.svg";


import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { DropdownType } from "../../base/CustomDropdown";
import AccountAdd from "./AccountAdd";
import AccountUpdate from "./AccountUpdate";
import { getTimestampToDate, parseLocaleDatetime } from "common/util";



export interface AccountData {
    user_id: string,
    user_role_type_code: string,
    project_role_type_code: string,
    user_status_code: string,
    alias: string,
    email: string,
    fullname: string,
    phone_number: string,
    company_name: string,
    department_name: string,
    department_rank: string,
    sms_notify_yn: boolean,
    email_notify_yn: boolean,
    last_login_ts: string,
    current_login_ts: string,
    first_login_yn: boolean,
    create_ts: string,
    update_ts: string,
    project: {
        project_id: string,
        project_name: string,
        project_description: string
    }
}



export interface AccountDetailData {
    alias: string,
    company_name: string,
    create_ts: string,
    current_login_ts: string,
    update_ts: string,
    department_name: string,
    department_rank: string,
    email: string,
    sms_notify_yn: boolean,
    email_notify_yn: boolean,
    first_login_yn: boolean,
    fullname: string,
    last_login_ts: string,
    password_change_ts: string,
    phone_number: string,
    project_role_type_code: string,
    user_id: string,
    user_role_type_code: string,
    user_status_code: string,
    project: {
        project_id: string,
        project_name: string,
        project_description: string,
    }
}


export const initAccountDetailData = {
    alias: '',
    company_name: '',
    create_ts: '',
    current_login_ts: '',
    update_ts: '',
    department_name: '',
    department_rank: '',
    email: '',
    sms_notify_yn: true,
    email_notify_yn: true,
    first_login_yn: true,
    fullname: '',
    last_login_ts: '',
    password_change_ts: '',
    phone_number: '',
    project_role_type_code: '',
    user_id: '',
    user_role_type_code: '',
    user_status_code: '',
    project: {
        project_id: '',
        project_name: '',
        project_description: ''
    }
}



export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("ACCOUNT_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "ACCOUNT_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "ACCOUNT_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("ACCOUNT_STATUS_CHANGE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.CONTROL_BUTTON,
        activeYn: true,
        controlButton: [
            {
                name: i18n.t("ACTIVE_TEXT"),
                code: "ACTION_ACTIVE",
            },
            {
                name: i18n.t("INACTIVE_TEXT"),
                code: "ACTION_INACTIVE",
            },
        ],
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("ACCOUNT_TYPE_TEXT"),
        accessor: "user_role_type_code",
        disableSortBy: true,
        style: {
            width: "140px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, display:"flex", alignItems: "center"}}>
            {
                value === "ADM"
                ? <>{i18n.t("ADMINISTRATOR_TEXT")}<AdminImg style={className.roleImg}/></>
                : <>{i18n.t("USER_MEMBER_TEXT")}<DomainImg style={className.roleImg}/></>
            }
            </div>
        )
    },
    {
        Header: i18n.t("ACCOUNT_ID_TEXT"),
        accessor: "email",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("NAME_TEXT"),
        accessor: "fullname",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("ACCOUNT_STATUS_TEXT"),
        accessor: "user_status_code",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.statusContainer}>
                {
                    (() => {
                        if(value === "ACT")
                            return (
                            <div style={{...className.statusInnerContainer, color:"#333"}}>
                                <ActiveImg style={className.statusImg}/> <>{i18n.t("ACTIVE_TEXT")}</>
                            </div>)
                        else if(value === "DACT")
                            return (
                                <div style={{...className.statusInnerContainer, color:"#333"}}>
                                <IdleImg style={className.statusImg}/><>{i18n.t("INACTIVE_TEXT")}</>
                            </div>)
                        else if(value === "DMC")
                            return (
                                <div style={{...className.statusInnerContainer, color:"#333"}}>
                                <LockImg style={className.statusImg}/><>{i18n.t("DORMANCY_TEXT")}</>
                            </div>)
                        else
                            return (
                                <div style={{...className.statusInnerContainer, color:"#333"}}>
                                <WithdrawImg style={className.statusImg}/><>{i18n.t("PENDING_WITHDRAW_TEXT")}</>
                            </div>)
                    })()
                }
            </div>
        )
    },
    {
        Header: i18n.t("ORGANIZATION_NAME_TEXT"),
        accessor: "company_name",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#3a8344"}}>{value}</div>)
    },
    {
        Header: i18n.t("PROJECT_TEXT"),
        accessor: 'project.project_name',
        disableSortBy: true,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.dateContainer}>{parseLocaleDatetime(value, false)}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.dateContainer, color: "#9ea0a5"}}>{parseLocaleDatetime(value, false)}</div>)
    },

];

export const accountAddModalContent = {
    title: i18n.t("ACCOUNT_ADD_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <AccountAdd />,
}


export const accountUpdateModalContent = {
    title: i18n.t("ACCOUNT_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <AccountUpdate />,
}


export const accountTypeCode:DropdownType[] = [
    {
        label: i18n.t("SUPER_ADMIN_TEXT"),
        value: "SPADM"
    },
    {
        label: i18n.t("DOMAIN_ADMIN_TEXT"),
        value: "DMADM"
    },
    {
        label: i18n.t("ROOT_USER_TEXT"),
        value: "RTUSR"
    },
    {
        label: i18n.t("SUB_USER_TEXT"),
        value: "SUBUSR"
    },
]


export const accountStatusCode:DropdownType[] = [
    {
        label: i18n.t("ACTIVE_TEXT"),
        value: "ACT"
    },
    {
        label: i18n.t("INACTIVE_TEXT"),
        value: "DIS"
    },
    {
        label: i18n.t("BLOCK_TEXT"),
        value: "BLK"
    },
    {
        label: i18n.t("DELETE_TEXT"),
        value: "DEL"
    },
]
export const genderTypes:DropdownType[] = [
    {
        value: "MALE",
        label: i18n.t("MALE_TEXT")
    },
    {
        value: "FMALE",
        label: i18n.t("FEMALE_TEXT")
    },
    {
        value: "NONE",
        label: i18n.t("UNKNOWN_TEXT")
    },
]
const className = {
    rowContainer: {
        width: "100%"
    },
    statusContainer: {
        width: "100px",
        display: "flex",
        alignItems: "center",
    },
    statusInnerContainer: {
        display: "flex", alignItems: "center",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#616266",
        overflow: "hidden"
    },
    statusInnerNoImageContainer: {
        marginLeft: 20,
        display: "flex",
        alignItems: "center",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#616266",
        overflow: "hidden"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3,
    },
    dateContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        lineHeight: "1",
        color: "#333",
        overflow: "hidden"
    },
    roleImg: {
        width: 22,
        height: 22
    },
}



